/** Shared between the CSV drop zones (first-import choices, global drop-anywhere). */
export function isCsvFile(file: File): boolean {
  if (file.type === "text/csv") return true
  return file.name.toLowerCase().endsWith(".csv")
}
